/*
 * Helper for styling
 */
'use strict';

jQuery($ => {
	/*
	 * Wrap every select in .select for custom dropdown icon
	 */
	$('select').each(function() {
		if ($(this).is(':visible') && !$(this).hasClass('select2-hidden-accessible')) {
			$(this).wrap('<div class="gecko-select"></div>');
		}
	});

});
